import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import fileDownload from "js-file-download";
import {baseURL} from "../Constant";

export const UserMaintanenceSlice = createSlice({
  name: "UserMaintanenceList",
  initialState: {
    UserMaintanenceData: [],
  },
  reducers: {
    setError: (state) => {
      state.error = true;
    },
    setUserMaintanenceData: (state, { payload }) => {
      state.error = false;
      state.UserMaintanenceData = payload;
    },
    updateUserMaintanenceData: (state, { payload }) => {
      state.error = false;      
      state.UserMaintanenceData = payload;
    },
  },
});

export const { setError, setUserMaintanenceData, updateUserMaintanenceData } =
  UserMaintanenceSlice.actions;

export default UserMaintanenceSlice.reducer;

export function getUserMaintanenceData() {
  return (dispatch) => {
    axios
      .get(`${baseURL}/fetchusermaintanencedata`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        let newArray;
        if (res.data != undefined && res.data != null) {
          newArray = res.data.map((item, index) => {
            const newItem = {
              id: index + 1,
              ...item,
            };
            return newItem;
          });
        }        
        dispatch(setUserMaintanenceData(newArray));        
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}

export function addUser(username,finalTrackVal,userRolesCB) {
  return (dispatch) => {
    axios
      .post(
        `${baseURL}/adduser`,
        { username,finalTrackVal, userRolesCB},
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        dispatch(getUserMaintanenceData());        
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}

export function submitUserRoles(roles) {
  return (dispatch) => {
    axios
      .post(
        `${baseURL}/adduserroles`,
        { roles },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        //  dispatch(updateUser(username));
        console.log("res from role based on ent id", res.data);
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}

export function updateSupervisor(Supervisor, Enterprise_ID) {
  return (dispatch) => {
    axios
      .put(
        `${baseURL}/updateSupervisor`,
        { Supervisor, Enterprise_ID },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        //  dispatch(updateUser(username));
        console.log("updated supervisor details");
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}

export function deleteEnterpriseID(Enterprise_ID_Del) {
  console.log("Enterprise id in redux", Enterprise_ID_Del);
  return (dispatch) => {
    axios
      .delete(`${baseURL}/deleteEnterpriseID/${Enterprise_ID_Del}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        dispatch(getUserMaintanenceData());
      })
      .catch((err) => {
        dispatch(setError(err));
        console.log("error in deleting Enterprise ID is", err);
      });
  };
}

export function downloadUserRoles() {
  return (dispatch) => {
    axios
      .get(
        `${baseURL}/downloadExcel`,
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        },
        {
          responseType: "blob",
        }
      )
      .then((res) => {
        fileDownload(res.data, `User Roles.xlsx`);
      })
      .catch((err) => {
        console.error("error is", err);
      });
  };
}

export function uploadUserRoles(formData) {
  return (dispatch) => {
    axios
      .post(`${baseURL}/uploaduserrole`, formData, {
        headers: {
          Authorization: localStorage.getItem("token"),
          // "Content-Type": "application/json",
        },
      })
      .then((res) => {
        // then print response status
        console.log(res);
      })
      .catch((err) => {
        // then print response status
        console.error("upload fail");
      });
  };
}
